
import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AddProfileDialogComponent } from "../add-profile-dialog/add-profile-dialog.component";
import { DataCatalogueService } from "../../services/data-catalogue.service";

export interface ProfileData {
  profile: string;
  read: boolean;
  create: boolean;
  update: boolean;
  decommission: boolean;
  mandatory: boolean;
  ref?: string;
}

@Component({
  selector: "app-feature-access-rights",
  templateUrl: "./feature-access-rights.component.html",
  styleUrl: "./feature-access-rights.component.scss",
})
export class FeatureAccessRightsComponent implements OnInit {
  aclData: any;
  profilesMap: Record<string, string> = {};

  displayedColumns: string[] = [
    "profile",
    "read",
    "create",
    "update",
    "decommission",
  ];

  dataSource: ProfileData[] = [];

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<FeatureAccessRightsComponent>,
    private catalogueService: DataCatalogueService,
    @Inject(MAT_DIALOG_DATA) public data: { feature?: string, object?: string }
  ) {}

  ngOnInit(): void {
    this.loadProfiles(() => {
      this.loadACL();
    });
  }

  private loadProfiles(done: () => void): void {
    this.catalogueService
      .getProfiles("2037172d-1390-4033-9017-e5424166927e")
      .subscribe({
        next: (profiles) => {
          this.profilesMap = {};

          profiles.forEach((p: any) => {
            this.profilesMap[p.uuid] = p.name;
          });

          done();
        },
        error: (err) => {
          console.error("Error loading profiles:", err);
          done();
        },
      });
  }

  private loadACL(): void {
    this.catalogueService
      .getItemACL(
        "2037172d-1390-4033-9017-e5424166927e",
        this.data.feature ? "features" : "objects",
        "aixm",
        this.data.feature ? this.data.feature : this.data.object
      )
      .subscribe({
        next: (res) => {
          console.log("Loaded ACL:", res);

          this.aclData = res;

          this.dataSource = res.map((item: any) => ({
            profile: this.profilesMap[item.ref] ?? item.ref,
            read: item.read,
            create: item.create,
            update: item.update,
            decommission: item.decommission,
            mandatory: item.mandatory ?? false,
            ref: item.ref,
          }));
          this.dataSource.push({
            profile: "Other profiles",
            read: false,
            create: false,
            update: false,
            decommission: false,
            mandatory: false,
          });
        },
        error: (err) => {
          console.error("Error loading ACL:", err);
        },
      });
  }
  onClose(): void {
    this.dialogRef.close();
  }
onSave(): void {
 const payload = this.dataSource
    .filter(p => p.ref) // samo oni koji imaju ref, iybacujem other profiles
    .map((p) => ({
      ref: p.ref,
      read: p.read,
      create: p.create,
      update: p.update,
      decommission: p.decommission,
      mandatory: p.mandatory,
    }));
        console.log("ACL updated successfully:", this.dataSource);

  this.catalogueService
    .updateItemACL(
      "2037172d-1390-4033-9017-e5424166927e",
      this.data.feature ? "features" : "objects",
      "aixm",
      this.data.feature ? this.data.feature : this.data.object,
      payload
    )
    .subscribe({
      next: (res) => {
        console.log("ACL updated successfully:", res);
        this.dialogRef.close(this.dataSource);
      },
      error: (err) => console.error("Error updating ACL:", err),
    });
}


  toggleRead(element: ProfileData): void {
    element.read = !element.read;
    if (!element.read) {
      element.create = false;
      element.update = false;
      element.decommission = false;
    }
  }

  toggleCreate(element: ProfileData): void {
    element.create = !element.create;
    if (element.create) {
      element.read = true;
    }
  }

  toggleUpdate(element: ProfileData): void {
    element.update = !element.update;
    if (element.update) {
      element.read = true;
    }
  }

  toggleDecommission(element: ProfileData): void {
    element.decommission = !element.decommission;
    if (element.decommission) {
      element.read = true;
    }
  }

  openAddProfileDialog(): void {
    const dialogRef = this.dialog.open(AddProfileDialogComponent, {
      width: "400px",
      data: {},
    });

    dialogRef.afterClosed().subscribe((selectedProfiles: any[]) => {
      if (selectedProfiles && selectedProfiles.length) {
        selectedProfiles.forEach((profile) => {
          const exists = this.dataSource.some(
            (p) => p.profile === profile.name
          );
          if (!exists) {
            this.dataSource.push({
              ref: profile.ref,
              profile: profile.name,
              read: false,
              create: false,
              update: false,
              decommission: false,
              mandatory: false,
            });
          }
        });

        this.dataSource.sort((a, b) => {
          if (a.profile === "Other profiles") return 1;
          if (b.profile === "Other profiles") return -1;
          return a.profile.localeCompare(b.profile);
        });

        this.dataSource = [...this.dataSource];
      }
    });
  }
}
